"use strict";

var _interopRequireWildcard = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SectionPanel = void 0;
var _defineProperty2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js"));
var _slicedToArray2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _react = _interopRequireWildcard(require("react"));
var _sectionPanelModule = _interopRequireDefault(require("./section-panel.module.scss"));
var _classnames = _interopRequireDefault(require("classnames"));
var _SecondaryNavigation = require("../secondary-navigation/SecondaryNavigation");
var SectionPanel = function SectionPanel(_ref) {
  var sections = _ref.sections,
    className = _ref.className;
  var _useState = (0, _react.useState)(0),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    selectedSectionIndex = _useState2[0],
    setSelectedSection = _useState2[1];
  var handleSectionChange = function handleSectionChange(sectionIndex) {
    setSelectedSection(sectionIndex);
  };
  var buildTabs = function buildTabs(sections) {
    var categories = sections.map(function (section, index) {
      var active = section.name === sections[selectedSectionIndex].name;
      return {
        id: section.name,
        title: section.name,
        active: active,
        onClick: function onClick() {
          return handleSectionChange(index);
        },
        className: (0, _classnames.default)(_sectionPanelModule.default['section-panel__tab-item'], (0, _defineProperty2.default)({}, _sectionPanelModule.default['section-panel__tab-item--active'], active))
      };
    });
    return /*#__PURE__*/_react.default.createElement(_SecondaryNavigation.SecondaryNavigation, {
      categories: categories,
      className: _sectionPanelModule.default['section-panel__tabs-nav']
    });
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": 'section-panel',
    className: (0, _classnames.default)(_sectionPanelModule.default['section-panel'], className)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _sectionPanelModule.default['section-panel__tabs']
  }, buildTabs(sections)), sections[selectedSectionIndex].content);
};
exports.SectionPanel = SectionPanel;